import { Button, Dialog, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import en from '../../../../lang/en-us';
import { GridRowId } from '@material-ui/data-grid';
import { CustomRadio } from '../../../../lib/CustomRadio';
import { connect } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import {
    ctPortfoliosByMinorStatus,
    DIVIDEND_MATCHED_UNMATCHED_DATA_TYPE,
    getDividendFilteredData,
    getErrorMessage,
    modeOfHoldingSingle,
    portfoliosByDividend,
    portfoliosByModeOfHolding,
    portfoliosByPayout,
    portfoliosByPurchaseAllow,
    portfoliosByReinvestment,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import { getPortfolio } from '../../../../redux-store/actions/portfolio';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import NoFoliosFound from '../../makeNct/NoFoliosFound';
import {
    OTP_ACTIONS,
    EQUITY,
    LIQUID,
    DEBT,
    OTHER,
    IDCW_OPTION,
    CommercialRootPath,
} from '../../../../utils/constants';
import { getMatchAndUnMatchedFunds, maskMobileNumber } from '../../../../utils/utilityFunctions';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { ActionHeader } from '../index';
import { apDividendFilters } from './types';

export interface DividendTableRowType extends SCHEMES_RESPONSE {
    id?: GridRowId;
    isDisabled?: boolean;
}

const { dbCommercial, dashboard } = en;

const columns: TableColumn[] = [
    { field: 'folio', headerName: 'Folio', width: 150 },
    {
        field: 'id',
        headerName: 'Scheme Name',
        valueGetter: ({ row }) => `${row?.amcName}-${row?.schemeName}`,
        width: 350,
        filterBy: true,
        filterHeader: 'AMC',
        filterKey: 'amcName',
        fullWidth: true,
    },
    { field: 'investorName', headerName: 'Primary Holder', width: 200 },
    {
        field: 'mobile',
        headerName: 'Mobile Number',
        width: 220,
        valueGetter: ({ row }) => maskMobileNumber(row?.mobile),
    },
    {
        isFilter: true,
        field: 'assetType',
        headerName: 'Category',
        filterBy: true,
        renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    },
];

function AdditionalPurchase(props: any) {
    const [rowData, setRowData] = useState<DividendTableRowType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { portfolios = {} } = props;
    const { data: folioList = [] } = portfolios;
    const {
        selectedRows,
        setSelectedRows,
        resetTable,
        resetFilters,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<DividendTableRowType[]>({
        initialSelectionModal: [],
        rows: rowData,
        columns,
        loading,
    });
    const [nomineeError, setNomineeError] = useState(false);

    useEffect(() => {
        setLoading(true);
        async function fetchPortfolio() {
            const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
            try {
                await props.getPortfolio({
                    pan,
                    pekrn,
                    mobile,
                    reqId,
                });
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
            }
        }
        fetchPortfolio();
    }, []);

    useEffect(() => {
        const schemeOptionsData = getDividendFilteredData(folioList);
        const data = getMatchAndUnMatchedFunds(apDividendFilters, schemeOptionsData, true);
        setRowData(data);
    }, [props.portfolios]);

    const handleSubmit = async () => {
        try {
            props.history.push(`ap-investment/${selectedRows[0].isin}?amc=${selectedRows[0].amc}`, {
                additionalPurchaseFolio: selectedRows[0],
                sipFlag: false,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dbCommercial.additionalPurchase.heading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <>
                        <h5> {dbCommercial.additionalPurchase.purchaseInfo}</h5>
                        {!!loading || tableRows.length ? (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                isRowSelectable={(params) => (params.row.isDisabled ? false : true)}
                                selectedRows={selectedRows}
                                setSelectedRows={setSelectedRows}
                                toolTipTextGetter={({ row }) =>
                                    getErrorMessage(row, apDividendFilters)
                                }
                                toolTipEnabled
                                radioGroupsEnabled
                                resetFilters={resetFilters}
                                {...filters}
                            />
                        ) : (
                            <NoFoliosFound info={'No Folios Found'} />
                        )}
                    </>
                </div>
                <div className="curved-bg-content-inner-bottom">
                    {!!rowData.length && (
                        <div className="table-submit">
                            <Button
                                className="customBtn"
                                disabled={!selectedRows.length}
                                onClick={handleSubmit}
                            >
                                {dashboard.ChangeDividend.buttonText}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            <Dialog
                onClose={() => props.history.goBack()}
                maxWidth={'sm'}
                open={nomineeError}
                aria-labelledby="transmission-main-modal"
            >
                <div className="note-modals transmission-main-modal">
                    <h3>{dbCommercial.exploreMfs.inactiveScheme}</h3>
                    <p>{dbCommercial.exploreMfs.inactiveSchemeInfo}</p>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn"
                            onClick={() => {
                                props.history.push(`/portal/update-nominee`);
                            }}
                        >
                            Proceed
                        </Button>
                        <Button className="customBtn" onClick={() => setNomineeError(false)}>
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { getPortfolio, sendPhoneOTP },
)(AdditionalPurchase);
